
export const GridConfig = {	
	grid: {
		gridId: 'PartnerCapitalReportGrid',
		height: 500,
		checkbox: true,
		edit: false,
		delete: false,
		document: false,
		groupable: true,
		sort: [{ field: "ReportDate", dir: "asc" }]
	},
	columns: {
		CapitalType: {
			class: "value",
			dataName: 'CapitalType',
			type: 'string',
			title: 'Capital Type',
			width: 180
		},
		Level: {
			class: "value",
			dataName: 'Level',
			type: 'string',
			title: 'Level',
			width: 100
		},
		PartnerId: {
			class: "lookup",
			dataName: 'PartnerId',
			type: 'number',
			title: 'Partner Id',
			width: 100,
			hidden: true,
			readOnly: true
		},
		PartnerID: {
			class: "lookup",
			dataName: 'Partner/PartnerID',
			type: 'number',
			title: 'Partner ID',
			width: 150,
		},
		PartnerName: {
			class: "lookup",
			dataName: 'Partner/FullName',
			type: 'string',
			title: 'Partner Name',
			width: 200,
		},
		ReportDate: {
			class: "value",
			dataName: 'ReportDate',
			type: 'date',
			title: 'Date',
			width: 150,
		},
		Currency: {
			class: "value",
			dataName: 'Currency',
			type: 'string',
			title: 'Currency',
			width: 150
		},
		CashContribution: {
			class: "value",
			dataName: 'CashContribution',
			type: 'currency',
			title: 'Cash Contribution',
			width: 200,
			template: '<span class="number-cell-ui">#=kendo.toString(CashContribution, "c")#</span>',
		},
		CashDistribution: {
			class: "value",
			dataName: 'Cash Distribution',
			type: 'currency',
			title: 'Cash Distribution',
			width: 200,
			template: '<span class="number-cell-ui">#=kendo.toString(CashDistribution, "c")#</span>',
		},
		PropertyDistribution: {
			class: "value",
			dataName: 'PropertyDistribution',
			type: 'number',
			title: 'Property Distribution',
			width: 250,
		},
	}
}